import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CheckExistsDocumentNameRequest, CheckExistsDocumentNameResponse, DocumentBodyRequest, GetDocumentListsRequest, GetDocumentListsResponse, ValidateBeforeRemoveDocumentRequest, ValidateBeforeRemoveDocumentResponce } from '@ptg-member/types/models/member-document.model';
import { SortType } from '@ptg-shared/constance';
import { isEmpty } from '@ptg-shared/utils/string.util';
import { Observable } from 'rxjs';
import { DocumentPortal } from 'src/app/app.const';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MemberDocumentService {
  documentFile?: File[];
  constructor(private httpClient: HttpClient) { }

  getDocumentLists(
    request: GetDocumentListsRequest
  ): Observable<GetDocumentListsResponse> {
    let params = new HttpParams();
    if (request?.sortNames?.length) {
      params = params.append('SortNames', request.sortNames);
      params = params.append('SortType', request?.sortType ?? SortType.ASC);
    }
    if (request?.pageSize && request?.pageNumber) {
      params = params.append('PageSize', request.pageSize);
      params = params.append('PageIndex', request.pageNumber);
    }
    if (request?.memberId) {
      params = params.append('MemberId', request.memberId);
    }

    if (request?.employerId) {
      params = params.append('EmployerId', request.employerId);
    }

    if (request.filters?.documentName) {
      params = params.append(`DocumentName`, request.filters?.documentName);
    }

    if (request.filters?.fileName) {
      params = params.append(`FileName`, request.filters?.fileName);
    }

    if (request.filters?.uploadedFrom) {
      params = params.append(`UploadedFrom`, request.filters?.uploadedFrom);
    }

    if (request.filters?.uploadedTo) {
      params = params.append(`UploadedTo`, request.filters?.uploadedTo);
    }

    if (request.filters?.uploadedTo) {
      params = params.append(`UploadedTo`, request.filters?.uploadedTo);
    }

    if (request.filters?.tagsDisplay) {
      request.filters?.tagsDisplay.forEach((item: any, idx: any) => {
        params = params.append(`DocumentTag[${idx}]`, item);
      });
    }

    if (request.filters?.types) {
      request.filters?.types.forEach((item: any, idx: any) => {
        params = params.append(`FileType[${idx}]`, item);
      });
    }

    if (request.filters?.showOnOverview !== null && request.filters?.showOnOverview !== undefined) {
      params = params.append(`IsShowOnOverView`, request.filters?.showOnOverview);
    }
    params = params.append('TimeZoneOffset', new Date().getTimezoneOffset());

    params = params.append('DocumentPortal', request.documentPortal as DocumentPortal);

    return this.httpClient.get<GetDocumentListsResponse>(
      `${environment.apiUrl}/member-portal/GetParticipantDocumentList`,
      { params }
    );
  }

  uploadDocuments(body: any): Observable<void> {
    const data = new FormData();
    data.append('ParticipantId', body.participantId || '');
    this.documentFile?.forEach((item: any) => {
      data.append('FileContents', item || '');
    })
    data.append('FileName', body.fileName || '');
    data.append('Description', body.description || '');
    data.append('ShowOnOverview', body.showOnOverview ?? false);
    data.append('DocumentName', body.documentName || '');
    data.append('DocumentLocationTitle', body.documentLocationTitle || '');
    data.append('DocumentLocationRouter', body.documentLocationRouter || '');
    if (!isEmpty(body?.participantDocumentType)) {
      data.append('ParticipantDocumentType', body.participantDocumentType);
    }
    data.append('DocumentPortal', body.documentPortal);
    data.append('EmployerId', body.employerId);
    return this.httpClient.post<void>(
      `${environment.apiUrl}/member-portal/document/upload-document`, data
    );
  }

  editDocuments(memberId: string, fileId: string, body: any): Observable<void> {
    return this.httpClient.put<void>(
      `${environment.apiUrl}/member-portal/${memberId}/document/${fileId}`, body
    );
  }

  removeDocument(body: DocumentBodyRequest): Observable<void> {
    return this.httpClient.delete<void>(
      `${environment.apiUrl}/member-portal/documents`, { body }
    );
  }

  validateBeforeRemoveDocument(body: ValidateBeforeRemoveDocumentRequest): Observable<ValidateBeforeRemoveDocumentResponce> {
    return this.httpClient.post<ValidateBeforeRemoveDocumentResponce>(
      `${environment.apiUrl}/member-portal/documents/validate-before-remove`, body
    );
  }

  checkExistDocumentName = (checkExistDocumentNameRequest: CheckExistsDocumentNameRequest) => {
    let params = new HttpParams();
    if (checkExistDocumentNameRequest?.documentId) {
      params = params.append('fileId', checkExistDocumentNameRequest.documentId);
    }
    if (checkExistDocumentNameRequest?.documentName) {
      params = params.append('documentName', checkExistDocumentNameRequest.documentName);
    }
    return this.httpClient.get<CheckExistsDocumentNameResponse>(
      `${environment.apiUrl}/member-portal/${checkExistDocumentNameRequest.memberId}/documents/exists`, { params }
    );
  }

  checkExistDocumentNameMultiple(memberId: string, body: string[]): Observable<any> {
    return this.httpClient.post<any>(
      `${environment.apiUrl}/member-portal/${memberId}/multiple-documents/exists`, body
    );
  }
}
